<template>
  <label
    class="c-switch"
    :class="[
      `c-switch--${props.size}`,
    ]"
  >
    <input v-model="checked" type="checkbox" :value="props.value" :disabled="props.disabled">
    <span v-if="$slots.default" class="flex flex-col">
      <slot />
    </span>
  </label>
</template>

<script setup lang="ts">
import { computed, withDefaults } from 'vue';
import { SwitchSize } from './types/SwitchSize';

const props = withDefaults(defineProps<{
  size?: SwitchSize,
  modelValue: string | boolean,
  value?: string | boolean,
  disabled?: boolean,
}>(), {
  size: 'medium',
  value: true,
  disabled: false,
});

const emit = defineEmits<{(e: 'update:modelValue', value: string | boolean): any}>();

const checked = computed<string | boolean>({
  get() {
    return props.modelValue;
  },
  set(val: string | boolean) {
    emit('update:modelValue', val);
  },
});
</script>

<script lang="ts">
export default {
  name: 'SeSwitch',
};
</script>
